import { useState } from 'react'
import { ReportTemplate } from '@/core/models/report.model'
import { useReportLicenseEnabled } from '@/features/report'
import { Box, Typography, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Stack, Pagination, Chip } from '@mui/material'
import { t, Trans } from '@lingui/macro'
import CreateReportTemplate from './CreateReportTemplateModal'
import DeleteTemplateModal from './DeleteTemplateModal'
import { ChipDate } from '@/components/ui/buttons/ChipButton/Chipdate'

export function TemplatesViewer({ templates }: { templates: ReportTemplate[] }) {
    const [page, setPage] = useState(1)
    const rowsPerPage = 10
    const hasLicense = useReportLicenseEnabled()
  
    const handleChange = (_event: React.ChangeEvent<unknown>, value: number) => {
      setPage(value)
    }
  
    const startIndex = (page - 1) * rowsPerPage
    const paginatedTemplates = templates.slice(startIndex, startIndex + rowsPerPage)
    const pageCount = Math.ceil(templates.length / rowsPerPage)
  
    return (
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="h6">{t`Available templates`}</Typography>
          <Box>{hasLicense && <CreateReportTemplate />}</Box>
        </Box>
        <TableContainer
          component={Paper}
          sx={{
            height: 500,
            overflowY: 'auto',
            position: 'relative',
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow
                sx={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                  backgroundColor: 'background.paper',
                }}
              >
                <TableCell>
                  <Trans>Title</Trans>
                </TableCell>
                <TableCell>
                  <Trans>Description</Trans>
                </TableCell>
                <TableCell>
                  <Trans>Creation date</Trans>
                </TableCell>
                <TableCell>
                  <Trans>Actions</Trans>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedTemplates.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Trans>You don't have any templates yet</Trans>
                  </TableCell>
                </TableRow>
              ) : (
                paginatedTemplates.map((template) => (
                  <TableRow key={template._id}>
                    <TableCell>
                      {template.isDefault ? (
                        <>
                          {template.title}
                          <Chip sx={{ ml: 1 }} label={t`default`} color="secondary" size="small" />
                        </>
                      ) : (
                        template.title
                      )}
                    </TableCell>
  
                    <TableCell>{template.description}</TableCell>
                    <TableCell>
                      <ChipDate date={template.createdAt} />
                    </TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={2}>
                        {hasLicense && <CreateReportTemplate isEdit={true} template={template} />}
                        {hasLicense && <DeleteTemplateModal templateId={template._id} />}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Stack spacing={2} sx={{ mt: 2, alignItems: 'center' }}>
          <Pagination count={pageCount} page={page} onChange={handleChange} variant="outlined" shape="rounded" showFirstButton showLastButton />
        </Stack>
      </Box>
    )
  }